module.exports = __webpack_public_path__ + "static/fonts/open-sans-regular.de0869e.woff";